<template>
	<div>
		<el-dialog :title="lotteryTaskText" width="900px" :visible.sync="addCopydialogFormVisible" append-to-body :close-on-click-modal="false">
			<el-form :model="form" :rules="rules" ref="form">
				<el-form-item label="任务名称" :label-width="formLabelWidth" prop="taskname">
					<el-input size="medium" placeholder="请输入任务名称" v-model="form.taskname" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="省、直辖市" :label-width="formLabelWidth" prop="provinces">
					<el-select size="medium" v-model="form.provinces" placeholder="请选择">
						<el-option label="请选择" value=""></el-option>
						<el-option v-for="(item, index) in provincesGrouped" :label="item" :value="item" :key="index"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="城市" :label-width="formLabelWidth" prop="city">
					<el-select size="medium" @visible-change="queryCity" v-model="form.city" placeholder="请选择">
						<el-option label="请选择" value=""></el-option>
						<el-option v-for="(item, index) in cityGrouped" :label="item" :value="item" :key="index"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="地区名称" :label-width="formLabelWidth" prop="area">
					<el-select size="medium" @visible-change="queryArea" v-model="form.area" placeholder="请选择">
						<el-option label="请选择" value=""></el-option>
						<el-option v-for="(item, index) in areaGrouped" :label="item" :value="item" :key="index"></el-option>
					</el-select>
					<el-button size="medium" type="primary" style="margin-left: 10px;" @click="queryTableData">获取局列表</el-button>
				</el-form-item>
				<div class="table">
					<el-table height="300" border :data="leftTableData" style="width: 100%" @selection-change="leftTableChange">
						<el-table-column type="selection" width="55" align="center"></el-table-column>
						<el-table-column prop="part" label="局名称" align="center"></el-table-column>
					</el-table>
					<div class="tableBtn">
						<div><el-button size="medium" type="primary" style="width: 80px;" @click="leftShift">左移</el-button></div>
						<div><el-button size="medium" type="primary" style="width: 80px; margin-top: 20px;" @click="rightShift">右移</el-button></div>
					</div>
					<el-table height="300" border :data="rightTableData" style="width: 100%" @selection-change="rightTableChange">
						<el-table-column type="selection" width="55" align="center"></el-table-column>
						<el-table-column prop="part" label="局名称" align="center"></el-table-column>
						<el-table-column prop="phoneLen" label="生成位数" align="center"></el-table-column>
						<el-table-column label="抽样数量" align="center">
							<template slot-scope="scope">
								<el-input size="mini" :disabled="form.randomtype != 1" v-model="scope.row.phonenum" autocomplete="off"></el-input>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="typeOfSampling">
					<el-form-item label="抽样类型" :label-width="formLabelWidth" prop="randomtype">
						<el-select size="medium" v-model="form.randomtype" placeholder="请选择抽样类型">
							<el-option label="自定义数量" value="1"></el-option>
							<el-option label="单个样本" value="2"></el-option>
							<el-option label="平均抽样" value="3"></el-option>
							<el-option label="随机抽样" value="4"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="数量" :label-width="formLabelWidth" v-if="form.randomtype != 1"  prop="phonenumcount">
						<el-input  size="medium" style="width: 100px;" placeholder="请输入数量" v-model="form.phonenumcount" autocomplete="off"></el-input>
						<el-button  size="medium" class="calculate" @click="calculateNum">计算</el-button>
					</el-form-item>
				</div>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button  size="medium" @click="resetForm('form')">取 消</el-button>
				<el-button  size="medium" type="primary" @click="saveAssignment('form')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	data() {
		return {
			leftSelection: [], //左侧选择
			rightSelection: [], //右侧选择
			lotteryTaskText: '添加抽样任务',
			leftTableData: [], //左侧
			rightTableData: [], //右侧
			addCopydialogFormVisible: false,
			form: {
				taskname: '',
				provinces: '',
				city: '',
				area: '',
				delivery: false,
				type: [],
				resource: '',
				desc: '',
				randomtype: '1',
				phonenumcount: 0
			},
			rules: {
				taskname: [
					{ required: true, message: '任务名称不能为空！', trigger: 'blur,change' }
				],
				provinces: [
					{ required: true, message: '请选择省份！', trigger: 'change' }
				],
				city: [
					{ required: true, message: '请选择城市！', trigger: 'change' }
				],
				area: [
					{ required: true, message: '请选择地区！', trigger: 'change' }
				],
				randomtype: [
					{ required: false }
				],
				phonenumcount: [
					{ required: false }
				],
			},
			provincesGrouped: [], //省分组
			cityGrouped: [], //城市分组
			areaGrouped: [], //地区分组
			formLabelWidth: '100px',
			editType: 1, //添加修改
			loading: false
		};
	},
	methods: {
		saveAssignment(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					if (this.rightTableData.length == 0) {
						this.$message.warning('请设置抽样任务与抽样数量！');
						return false;
					}
					let url = `${this.$config.service.insertPhoneTask}`;
					let that = this;
					let params = {
						that: this,
						url: url,
						method: 'POST',
						data: {
							taskname: that.form.taskname,
							provinces: that.form.provinces,
							city: that.form.city,
							area: that.form.area,
							randomtype: that.form.randomtype,
							phonenumcount: that.form.phonenumcount,
							partlist: that.rightTableData,
							nation: '中国',
							nationCode: '+86'
						},
						cb(res) {
							if (res.code == 0) {
								console.log(res.resultBody);
								that.resetForm(formName)
								that.$emit('saveOk');
								that.$message.success(res.message);
							} else {
								that.$message.error(res.message);
							}
						}
					};
					this.$util.request(params);
				} else {
					console.log('error submit!!');
					return false;
				}
			});
			
		},
		resetForm(formName) {
			this.rightTableData = []
			this.$refs[formName].resetFields();
			this.addCopydialogFormVisible = false;
		},
		// 计算
		calculateNum() {
			let num = Number(this.form.phonenumcount);
			if (num == NaN) {
				this.$message.warning('请输入数字');
				return false;
			}
			if (num == 0) {
				this.$message.warning('请输入大于0的数量');
				return false;
			}
			if (this.form.randomtype == 2) {
				if(this.rightTableData.length==0){
					this.$message.warning('请选择要右移的数据');
					return false
				}
				// 单个样本
				this.rightTableData.forEach(item => {
					item.phonenum = num;
				});
			} else if (this.form.randomtype == 3) {
				if(this.rightTableData.length==0){
					this.$message.warning('请选择要右移的数据');
					return false
				}
				// 平均抽样
				let average = num / this.rightTableData.length;
				
				this.rightTableData.forEach(item => {
					item.phonenum = Math.floor(average);
				});
			} else if (this.form.randomtype == 4) {
				if(this.rightTableData.length==0){
					this.$message.warning('请选择要右移的数据');
					return false
				}
				// 随机抽样
				let total = num;
				let len = this.rightTableData.length;
				let randomList = this.fillWithRandom(total, len);
				
				this.rightTableData.forEach((item, index) => {
					item.phonenum = randomList[index];
				});
			}
			this.$forceUpdate();
		},
		// 根据输入数值获取随机的数值组
		fillWithRandom(total, len) {
			let arr = new Array(len);
			let sum = 0;
			do {
				for (let i = 0; i < len; i++) {
					arr[i] = Math.random();
				}
				sum = arr.reduce((acc, val) => acc + val, 0);
				let scale = (total - len) / sum;
				arr = arr.map(val => Math.min(Math.round(val * scale) + 1));
				sum = arr.reduce((acc, val) => acc + val, 0);
			} while (sum - total);
			return arr;
		},
		// 查重
		findItem(arr, key, val) {
			for (let i = 0; i < arr.length; i++) {
				if (arr[i][key] == val) {
					return i;
				}
			}
			return -1;
		},
		leftShift() {
			if (this.rightSelection.length == 0) {
				this.$message.warning('请选择要右移的数据');
				return false;
			}
			this.rightTableData = this.rightTableData.filter(item => 
				!this.rightSelection.some(newItem => newItem.id === item.id)
			);
			// 添加到右侧数据中进行判断查重
			this.rightSelection.forEach(item => {
				let index = this.findItem(this.leftTableData, 'id', item.id);
				if (index == -1) {
					this.leftTableData.push(item);
				}
			});
		},
		rightShift() {
			if (this.leftSelection.length == 0) {
				this.$message.warning('请选择要右移的数据');
				return false;
			}
			// this.leftSelection;
			// 将选中的左侧数据从左侧数据中切除
			this.leftTableData = this.leftTableData.filter(item => 
				!this.leftSelection.some(newItem => newItem.id === item.id)
			);
			// 添加到右侧数据中进行判断查重
			this.leftSelection.forEach(item => {
				let index = this.findItem(this.rightTableData, 'id', item.id);
				if (index == -1) {
					this.rightTableData.push(item);
				}
			});
		},
		leftTableChange(val) {
			console.log('val :>> ', val);
			this.leftSelection = val;
		},
		rightTableChange(val) {
			this.rightSelection = val;
		},
		queryTableData() {
			if (this.form.provinces == '') {
				this.$message.warning('请选择省份');
				return false;
			}
			if (this.form.city == '') {
				this.$message.warning('请选择城市');
				return false;
			}
			if (this.form.area == '') {
				this.$message.warning('请选择地区');
				return false;
			}
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.getPhoneLibPartList}`,
				method: 'POST',
				data: {
					provinces: that.form.provinces,
					city: that.form.city,
					area: that.form.area,
					currentPage: 1,
					pageSize: 10000
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res.resultBody);
						let data = res.resultBody;
						data.forEach(item => {
							item.phonenum = 0;
						});
						that.leftTableData = data;
					} else {
						that.leftTableData = [];
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},

		addVisible() {
			this.editType = 1;
			this.lotteryTaskText = '添加抽样任务';
			this.queryProvinces();
			this.form = {
				taskname: '',
				provinces: '',
				city: '',
				area: '',
				delivery: false,
				type: [],
				resource: '',
				desc: '',
				randomtype: '1',
				phonenumcount: 0
			};
			this.addCopydialogFormVisible = true;
		},
		editVisible(id) {
			this.editType = 2;
			this.lotteryTaskText = '复制抽样任务';
			this.queryProvinces();
			this.copyData(id);
			this.addCopydialogFormVisible = true;
		},
		copyData(id) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryPhoneTaskByID}`,
				method: 'POST',
				data: {
					id: id
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res.resultBody);
						res.resultBody.baseInfo.randomtype = res.resultBody.baseInfo.randomtype.toString();
						that.form = res.resultBody.baseInfo;

						that.rightTableData = res.resultBody.partlist;
					} else {
						that.rightTableData = [];
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		// 查询省
		queryProvinces() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.getPhoneLibProviceGroup}`,
				method: 'POST',
				data: {
					id: that.surveyId
				},
				cb(res) {
					if (res.code == 0) {
						let arr = res.resultBody;
						let newArr = arr.filter(function(value, index, self) {
							return self.indexOf(value) === index;
						});
						that.provincesGrouped = newArr;
					} else {
						that.provincesGrouped = [];
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		// 查询城市
		queryCity(value) {
			if (value) {
				let that = this;
				let params = {
					that: this,
					url: `${this.$config.service.getPhoneLibCityGroup}`,
					method: 'POST',
					data: {
						provinces: that.form.provinces
					},
					cb(res) {
						if (res.code == 0) {
							let arr = res.resultBody;
							let newArr = arr.filter(function(value, index, self) {
								return self.indexOf(value) === index;
							});
							that.cityGrouped = newArr;
						} else {
							that.$message.error(res.message);
							that.cityGrouped = [];
						}
					}
				};
				this.$util.request(params);
			}
		},
		queryArea(value) {
			if (value) {
				let that = this;
				let params = {
					that: this,
					url: `${this.$config.service.getPhoneLibAreaGroup}`,
					method: 'POST',
					data: {
						provinces: that.form.provinces,
						city: that.form.city
					},
					cb(res) {
						if (res.code == 0) {
							let arr = res.resultBody;
							let newArr = arr.filter(function(value, index, self) {
								return self.indexOf(value) === index;
							});
							that.areaGrouped = newArr;
						} else {
							that.$message.error(res.message);
							that.areaGrouped = [];
						}
					}
				};
				this.$util.request(params);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.table {
	display: flex;
	min-height: 300px;
	margin-bottom: 20px;
	.tableBtn {
		width: 150px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		text-align: center;
	}
}
.typeOfSampling {
	display: flex;
	.calculate {
		margin-left: 10px;
	}
}
</style>
